<script setup lang="ts">
import { computed } from "vue";

import { toggleActions } from "@/action/toggleActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { action } from "@/components/action/action";
import { boardKey } from "@/components/board/injectKeys";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import { injectStrict } from "@/utils/vue";

import { isActionVisible } from "../actions";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);

const isVisible = computed(() => isActionVisible("activity", card, board.value));
</script>

<template>
  <IconButton v-if="isVisible" v-bind="action(toggleActions.toggleCardHistory)" />
</template>
